module.exports = __webpack_public_path__ + "assets/img/c987ceab9063e2f10bc9d6eee42ffd41.png";